import { useMemo, useRef } from 'react';
/**
 * Takes an array of items and adds a default item to the top of the list if:
 * 1. defaultDisplayValue is provided
 * 2. The `searchText` is empty or
 *    The `searchText` is contained (case insensitive) in the default item display text.
 * @param items List of items filtered on `searchText`
 * @param displayProp The item prop containing display text
 * @param searchText The current search text that is filtering the items
 * @param defaultDisplayValue The display text to set as the default item `displayProp` value
 */
export function useFilteredItemsWithDefaultValue(items, displayProp, searchText, defaultDisplayValue) {
  // Exclude search text from updating the memo. This ensures that adding /
  // removing of the default item stays in sync with data loading. Otherwise,
  // the item can move while data is still loading.
  var searchTextRef = useRef('');
  searchTextRef.current = searchText;
  return useMemo(() => {
    // If the list is still loading, items will exist, but their item prop will be undefined
    var isLoading = items.length > 0 && items[0].item == null;
    if (!isLoading && defaultDisplayValue != null && (searchTextRef.current === '' || defaultDisplayValue.toLowerCase().includes(searchTextRef.current.toLowerCase()))) {
      return [{
        key: defaultDisplayValue,
        item: {
          [displayProp]: defaultDisplayValue
        }
      }, ...items];
    }
    return items;
  }, [defaultDisplayValue, displayProp, items]);
}
export default useFilteredItemsWithDefaultValue;
//# sourceMappingURL=useFilteredItemsWithDefaultValue.js.map